import { render, staticRenderFns } from "./PluginCard.vue?vue&type=template&id=28e904f0&scoped=true&"
import script from "./PluginCard.vue?vue&type=script&lang=js&"
export * from "./PluginCard.vue?vue&type=script&lang=js&"
import style0 from "./PluginCard.vue?vue&type=style&index=0&id=28e904f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e904f0",
  null
  
)

export default component.exports